import React, {useEffect, useState} from 'react';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import {Button, Form, Grid, Header, Icon, Input, Menu, Segment} from "semantic-ui-react";
import Axios from "axios";
import Constants from "../../../../config/constants";
import objDefault from "../../../../models/homeModel";
import moment from "moment";
import {DatesRangeInput} from "semantic-ui-calendar-react";
import {staff, staff_search} from "../../../../config/staff";
const mystyle = {
    display: "none",

};

const ExportPatient = () => {
    const [input, setInput] = useState({
        ...objDefault
    });
    const [users, setUsers] = useState([]);
    const handleValueChange = (e) => {
        const {
            name, value
        } = e.target;
        setInput((prevInput) => ({
            ...prevInput,
            [name]: value,
        }))
    };

    useEffect(() => {
        search()
    }, []);
    const search = async (page = 1) => {
        try {
            setUsers([])
            let result = await Axios.get('http://' + Constants.url + ':' + Constants.port + '/v1/snr/opnote-excel?name=' + input.name + '&staff_id=' + input.staff_id + '&admission_range=' + input.admission_range + '&created_range=' + input.created_range + '&hn=' + input.hn + '&export_excel=1',
                {
                    headers: {
                        Authorization: Constants.headerAuthorization,
                        'Content-Type': 'application/json'
                    }
                }
            )
            setUsers(result.data.data);
        } catch (e) {
            console.log(e);
        }
    }
    return (
        <div style={{display: "flex", minHeight: "90vh", flexDirection: "column"}}>
            <br/>
            <br/>
            <div style={{flex: 1}}>
                &nbsp; &nbsp; &nbsp; &nbsp;
                <Grid style={{marginTop: "1em", marginLeft: "2em"}}>
                    <Grid.Row>

                        <Grid.Column width={15}>
                            <Segment color='teal' raised>
                                <Header as='h3' block>
                                    ค้นหาข้อมูล

                                </Header>

                                <Form>
                                    <Grid.Column>
                                        <Form.Group widths='equal'>

                                            <Form.Field

                                                control={Input}
                                                name='hn'
                                                label='HN'
                                                placeholder='HN'
                                                onChange={(e) => handleValueChange(e)}
                                            />
                                            <Form.Field

                                                control={Input}
                                                name='name'
                                                label='ชื่อ-นามสกุลคนไข้'
                                                placeholder='ชื่อ-นามสกุล'
                                                onChange={(e) => handleValueChange(e)}
                                            />

                                            <Form.Select

                                                fluid label='ชื่ออาจารย์'
                                                name='staff_id'
                                                value={input.staff_id}
                                                options={staff_search}
                                                placeholder='ชื่ออาจารย์'
                                                onChange={(e, {name, value}) => handleValueChange({
                                                    target: {
                                                        name,
                                                        value
                                                    }
                                                })}
                                                required={'true'}

                                            />

                                            <DatesRangeInput
                                                label='ช่วงเวลา admission'
                                                name="admission_range"
                                                placeholder="From - To"
                                                value={input.admission_range}
                                                iconPosition="left"
                                                onChange={(e, {name, value}) => handleValueChange({
                                                    target: {
                                                        name,
                                                        value
                                                    }
                                                })}
                                            />

                                            <DatesRangeInput
                                                label='ช่วงเวลา ที่บันทึกข้อมูล'
                                                name="created_range"
                                                placeholder="From - To"
                                                value={input.created_range}
                                                iconPosition="left"
                                                onChange={(e, {name, value}) => handleValueChange({
                                                    target: {
                                                        name,
                                                        value
                                                    }
                                                })}
                                            />

                                        </Form.Group>
                                    </Grid.Column>
                                </Form>
                                <Grid centered>
                                    <Grid.Column/>
                                    <Grid.Row centered columns={4}>
                                        <Grid.Column/>
                                        <Button icon primary
                                                onClick={() => search()}
                                        >
                                            <Icon name='search'/> ค้นหา
                                        </Button>

                                        <Grid.Column/>
                                    </Grid.Row>
                                </Grid>


                            </Segment>

                        </Grid.Column>


                    </Grid.Row>
                    <Grid.Row>

                        <Grid.Column width={15}>
                            <Segment color='teal' raised>
                                <ReactHTMLTableToExcel
                                    id="test-table-xls-button"
                                    className="btn btn-success"
                                    table="table-to-xls"
                                    filename="tablexls-op-note.xlsx"
                                    sheet="tablexls"
                                    buttonText="Download as XLS (opNote)"/>
                                <br/> <br/>
                                <table id="table-to-xls" class={'table-bordered'} style={{width: '100%'}}>
                                    <tr class={'active'}>
                                        <th>#</th>
                                        <th>HN</th>
                                        <th>ชื่อ-นามสกุล</th>
                                        <th>เพศ</th>
                                        <th>admission</th>
                                        <th>Date of operation</th>
                                        <th>Time start</th>
                                        <th>Time end</th>
                                        <th>Admission diagnosis</th>
                                        <th>Chief complaint</th>
                                        <th>Clinical diagosis</th>
                                        <th>date op note</th>
                                        <th style={mystyle}>First assistant</th>
                                        <th style={mystyle}>assistant2</th>
                                        <th style={mystyle}>assistant3</th>
                                        <th style={mystyle}>assistant4</th>
                                        <th style={mystyle}>assistant5</th>
                                        <th style={mystyle}>assistant6</th>
                                        <th style={mystyle}>Surgeon</th>
                                        <th style={mystyle}>Scrub nurse</th>
                                        <th style={mystyle}>Post-operative diagnosis</th>
                                        <th style={mystyle}>Anesthesia</th>
                                        <th style={mystyle}>Anesthesiologist</th>
                                        <th style={mystyle}>Surgical-wound-classification</th>
                                        <th style={mystyle}>Position</th>
                                        <th style={mystyle}>Incision</th>
                                        <th style={mystyle}>Procedure</th>
                                        <th style={mystyle}>Estimate Blood loss (ml.)</th>
                                        <th style={mystyle}>Immediate post-operative complication</th>
                                        <th style={mystyle}>Findings-detail-1</th>
                                        <th style={mystyle}>Findings-detail-2</th>
                                        <th style={mystyle}>Findings-detail-3</th>
                                        <th style={mystyle}>Findings-detail-4</th>
                                        <th style={mystyle}>Findings-detail-5</th>
                                        <th style={mystyle}>department</th>
                                        <th style={mystyle}>ward</th>
                                        <th style={mystyle}>staff</th>
                                        <th style={mystyle}>resident</th>

                                    </tr>
                                    {

                                        users.map((user, index) => (
                                            <tr>
                                                <td>{index + 1}</td>
                                                <td>{user.hn}</td>
                                                <td>{user.fullname}</td>
                                                <td>{user.gender}</td>
                                                <td >{moment(user.admission_date).format("DD-MM-YYYY")}</td>
                                                <td >{moment(user.op_date_operation).format("DD-MM-YYYY")}</td>
                                                <td >{user.op_time_start}</td>
                                                <td >{user.op_time_end}</td>
                                                <td >{user.primary_diagnosis}</td>
                                                <td >{user.chief_complaint}</td>
                                                <td >{user.clinical_diagosis_op}</td>
                                                <td >{moment(user.date).format("DD-MM-YYYY")}</td>
                                                <td style={mystyle}>{user.first_assistant}</td>
                                                <td style={mystyle}>{user.assistant_name1}</td>
                                                <td style={mystyle}>{user.assistant_name2}</td>
                                                <td style={mystyle}>{user.assistant_name3}</td>
                                                <td style={mystyle}>{user.assistant_name4}</td>
                                                <td style={mystyle}>{user.assistant_name5}</td>
                                                <td style={mystyle}>{user.surgeon}</td>
                                                <td style={mystyle}>{user.scrub_nurse}</td>
                                                <td style={mystyle}>{user.operative_procedure}</td>
                                                <td style={mystyle}>{user.anesthesia}</td>
                                                <td style={mystyle}>{user.anesthetist}</td>
                                                <td style={mystyle}>{user.surgical_w_classification}</td>
                                                <td style={mystyle}>{user.position}</td>
                                                <td style={mystyle}>{user.incision}</td>
                                                <td style={mystyle}>{user.procedure}</td>
                                                <td style={mystyle}>{user.estimate_blood}</td>
                                                <td style={mystyle}>{user.complication}</td>
                                                <td style={mystyle}>{user.findings_1}</td>
                                                <td style={mystyle}>{user.findings_2}</td>
                                                <td style={mystyle}>{user.findings_3}</td>
                                                <td style={mystyle}>{user.findings_4}</td>
                                                <td style={mystyle}>{user.findings_5}</td>
                                                <td style={mystyle}>{user.department}</td>
                                                <td style={mystyle}>{user.ward}</td>
                                                <td style={mystyle}>{staff.find(item => item.key == user.staff_id_admission).text}</td>
                                                <td style={mystyle}>{user.resident}</td>


                                            </tr>
                                        ))
                                    }

                                </table>
                            </Segment>

                        </Grid.Column>
                    </Grid.Row>
                </Grid>


            </div>

        </div>
    );
}


export default ExportPatient
